<template>
  <body>
    <div class="container games-container">
      <div>
        <div v-if="windowSizeBelowThreshold && !usingMobile">
          <h3 class="screen-size-under-threshold">
            Please make sure your window size is at least 1200 x 700 pixels 
          </h3>
        </div>
        <div 
          v-if="usingMobile"
          class="mobile-game-disclaimer"
        >
          <p>Mobile-Compatible games coming soon</p>
        </div>
        <!-- <button @click="() => { toggleShowGame('/games/Cubulus/WebGL/v1/index.html'); }">
            <p style="font-size: 2rem;">
              CUBULUS
            </p>
          </button> -->
        <ul
          v-if="!windowSizeBelowThreshold"
          class="nav nav-pills pill-container"
        >
          <li class="nav-item">
            <button
              class="game-btn"
              @mouseover="toggleShowInfo(0, 'CubulusIcon.png')"
              @mouseleave="showInfo = false"
              @click="toggleShowGame('/games/Cubulus/WebGL/index.html')"
            >
              <span
                class="game-title"
              > CUBULUS </span>
            </button>
          </li>
          <li
            class="
                nav-item"
          >
            <button
              class="game-btn"
              @mouseover="toggleShowInfo(1, 'robot3_blaster1_akimbo.png')"
              @mouseleave="showInfo = false"
              @click="toggleShowGame('/games/RogueLikeTest/WebGL/index.html')"
            >
              <span
                class="game-title"
              > 
                CAUSTIC ARENA
              </span>
            </button>
          </li>
          <li class="nav-item x-button"> 
            <button
              class="game-btn"
              @click="toggleHighScores"
            >
              <span class="close-games">Leaderboards</span>
            </button>
          </li>
          <li class="nav-item"> 
            <button
              class="game-btn"
              @click="closeGamesPage"
            >
              <span class="close-games">X</span>
            </button>
          </li>
        </ul>
        <iframe
          v-if="(showGame && !windowSizeBelowThreshold)"
          class="game"
          :src="gameSRC"
          title="GameWindow"
          :style="usingMobile ? 'transform: rotate(90deg);' : ''"
        />
        <div
          v-if="!showGame && !windowSizeBelowThreshold && !usingMobile && !showHighScores"
          id="game-placeholder"
        >
          <div id="inner-placeholder">
            <h2
              v-if="!showInfo"
              style="padding-top: 3rem;"
            >
              Select a Game to Play
            </h2>
            <img
              v-if="!showInfo"
              id="controller-img"
              src="../assets/images/controller.svg"
            >
            <div
              v-if="!showInfo"
              class="high-score-name-field"
            >
              (Optional) Enter Name for High Scores<input
                v-model="highScoreName"
                placeholder="  blank = anonymous"
                maxlength="24"
              >
            </div>
            <img
              v-if="showInfo"
              id="game-icon"
              :src="require(`@/assets/images/${imgPath}`)"
            >
            <div v-if="showInfo">
              <h3 style="padding-top: 3rem; padding-bottom: 1rem;">
                {{ game_Info[gameIndex].Name }}
              </h3>
              <h4 style="text-align: left; margin-left: 1rem;">
                <span style="color: gold;">How to play:</span> <br>{{ game_Info[gameIndex].HowToPlay }}
              </h4>
              <br>
              <h4 style="text-align: left; margin-left: 1rem;">
                <span style="color: gold;">
                  Controls:
                </span>
                <div
                  v-for="control in gameControls"
                  :key="control.id"
                >
                  {{ control }}
                </div>
              </h4>
            </div>
          </div>
        </div>
        <HighScores v-if="showHighScores" />
      </div>
    </div>
  </body>
</template>

<script setup>
  import HighScores from "./HighScores.vue";
  import gameInfo from '../data/game_info.json';
  import { detectMobile } from '../utils/detectMobile.js';
  import { onMounted, computed, onUnmounted, ref  } from "vue";

  const showHighScores = ref(false);
  const showGame = ref(false);
  const showInfo = ref(false);
  const gameSRC = ref('');
  const game_Info = ref(gameInfo);
  const game_Index = ref(0);
  const img_Path = ref('CubulusIcon.png');
  const usingMobile = ref(false);
  const windowSizeBelowThreshold = ref(false);
  const MIN_HEIGHT = 700;
  const MIN_WIDTH = 1200;
  const iframeRotated = ref(false);
  const emit = defineEmits(['closeGamesPage']);
  const highScoreName = ref(undefined);

  const setHighScoreName = () => {
    localStorage.setItem("playerName", highScoreName.value);
  };

  const setWindowDimensions = () => {
    windowSizeBelowThreshold.value = window.innerWidth * window.devicePixelRatio  < MIN_WIDTH || window.innerHeight * devicePixelRatio < MIN_HEIGHT;
  }
  setWindowDimensions();
    
  const gameIndex = computed(() => {
      return game_Index.value;
    });

  const gameControls = computed(() => {
      return gameInfo[game_Index.value].Controls;
    });
  
  const imgPath = computed(() => {
      return img_Path.value;
    });

  onUnmounted(() => {
    window.removeEventListener('resize', setWindowDimensions)
  })
  
  onMounted(() => {
    highScoreName.value = localStorage.getItem('playerName');
    usingMobile.value = detectMobile();
    window.addEventListener('resize', setWindowDimensions);
    window.addEventListener("keydown", (e) => {
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
    e.preventDefault();
    return false;
  }
});
document.addEventListener("keydown", function (e) {
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
    e.preventDefault();
  }
});
  })

  const closeGamesPage = () => {
    emit('closeGamesPage');
  }

  const toggleHighScores = () => {
    showHighScores.value = !showHighScores.value;
    if(showHighScores.value) showGame.value = false;
  }
    
  const toggleShowGame = (gameSrc) => {
    showGame.value = !showGame.value;
    showHighScores.value = false;
    if (showGame.value){ gameSRC.value = gameSrc; if(highScoreName.value.length > 0) setHighScoreName(); }
  }

  const toggleShowInfo = (index, imgPath) => {
    game_Index.value = index;
    img_Path.value = imgPath;
    showInfo.value = true;
  }


</script>

<style lang="scss" scoped>
  $xs: 0px;
  $sm: 576px;
  $md: 768px;
  $lg: 992px;
  $xl: 1200px;

body {
  border-style: dotted;
  border-spacing: 1em;
  font-family: 'Russo One', sans-serif;
  background-color: black;
  text-align: center;
  min-height: 98vh;
  margin: .55rem;
}

h1, h3, p {
  font-family: 'Russo One', sans-serif;
  color: gold;
  text-align: center;
  text-shadow: 0px 3px rgba(190, 36, 190, 0.5);
}

iframe {
  border-color: rgb(33, 37, 41);
  border-width: 2px;
  border-style: dashed;
  height: 640px;
  width: 1100px;
}

// iframe:hover {
//   border-color: orange;
// }

.game-title {
  color: white;
}

.close-games {
  color: white;
  font-size: 1.25rem;
  line-height: 1rem;
}

#game-placeholder {
  font-family: 'Russo One', sans-serif;
  border-color: rgb(33, 37, 41);
  border-width: 2px;
  border-style: dashed;
  width: 1100px;
  height: 640px;
  background-color: black;
}

#inner-placeholder {
  width: 1000px;
  height: 560px;
  background-color: black;
  position: relative;
  top: 5.45%;
  left: 4%;
}

#controller-img {
  position: absolute;
  top: 25%;
  left: 25%;
  height: 50%;
  width: 50%;
}

#controller-img  svg {
  color: red;
}

#game-icon {
  position: absolute;
  top: 50%;
  left: 65%;
  height: 25%;
  width: 15%;
  border-radius: 1px;
  border-style: dashed;
}

.game-btn {
  background-color: black;
  border: 1px gray dashed;
  font-family: 'Russo One', sans-serif;
}

.game-btn:hover {
  filter: brightness(60%);
}

.screen-size-under-threshold {
  border: .25rem;
  background-color: black;
  border: 1px white solid;
  color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mobile-game-disclaimer {
  color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mobile-game-disclaimer > p {
  background-color: black;
  border: 1px dashed gray;
  line-height: 20px;
  text-shadow: none;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 1rem;
  @media(min-width: $sm) {
    font-size: 1.35rem;
  }
  color: white;
  white-space: nowrap;
}

.games-container {
  position: fixed;
  top: 22%;
  @media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 1.25dppx), (min-resolution: 120dpi){
    top: 9%;
  }  
}


.pill-container {
  width: 1100px;
  justify-content: flex-start;
}

.x-button {
  margin-left: auto;
}

.high-score-name-field {
  position: absolute;
  top: 85%;
  left: 25%;
  height: 50%;
  width: 50%;
}

/* TODO: Add Bounce Master, add links to itch.io/google play/steam(maybe ?) "Also available at..." */ 
</style>
